import React, { Component } from 'react'
import pick from 'lodash.pick'
import { compose } from 'react-apollo'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Mapa from '../../templates/Mapa'
import MapaGetInfoWindow from './Mapa.getInfoWindow'
import { fetchCities } from '../../../actions/cities'
import { addLayers, deleteLayer, editLayer, sortLayers } from '../../../actions/layers'

class MapaContainer extends Component {
  async componentDidMount () {
    const { fetchCities } = this.props

    // Remove old cities requests
    // fetchCities()
  }

  render () {
    const layerActions = pick(this.props, ['addLayers', 'deleteLayer', 'editLayer', 'sortLayers'])
    const props = pick(this.props, ['citiesLayer', 'getInfoWindow', 'layers'])

    Object.assign(props, { layerActions })

    return (
      <Mapa
        {...props}
        onChangeLanguage={this.onChangeLanguage} />
    )
  }
}

const mapStateToProps = ({ cities, layers }) =>
  (Object.assign({
    citiesLayer: cities.data,
    layers
  }))

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCities,
  addLayers,
  deleteLayer,
  editLayer,
  sortLayers
}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  MapaGetInfoWindow
)(MapaContainer)



// WEBPACK FOOTER //
// ./src/components/pages/Mapa/Mapa.container.js